import { Feature } from '@tencent/workbench';
import {  IChartDataLabelFormatShower } from '@tencent/chart-drawer-components/lib/interface';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { IDataLabelProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-label/data-label.interface';

const DEFAULT_FORMAT_CODE = 'General';

@Feature({
    name: 'ChartDataLabelFormatFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartDataLabelFormatShower,
})
export class ChartDataLabelFormatShower extends ChartBaseDrawerFeature implements IChartDataLabelFormatShower {
    /**
     * 获取格式
     */
    public getFormat = (): string => {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return '';
        const dataLabel = model.getSelectedElementProperty() as unknown as IDataLabelProperty;
        return dataLabel?.numFmt?.formatCode || DEFAULT_FORMAT_CODE;
    };
}
